import { WorkshopCoordinates } from '../common-types/workshop';

export default function getLocationCoordinates(location: string): WorkshopCoordinates {
  const items = location.split(',');
  const lat = Number(items[0]);
  const lng = Number(items[1]);
  return { lat, lng };
}
